import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStore } from "../+state/auth";

export const SecretariatGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.primaryOrganization()?.isSecretariat) {
    return true;
  }

  router.navigate(["not-found"]);

  return false;
};
